module.exports = __webpack_public_path__ + "static/media/sliten.b9bc308c.mp3";